module.exports = __webpack_public_path__ + "img/what-we-sell_0004.9ae58b3c.jpg";